import { useMemo } from 'react'
import { GENDERS } from 'Data/constants.js'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let selectedGender = useDataValue({
    context: 'appointment_overlay',
    path: 'patient_new.person.gender',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    return GENDERS.map(item => ({
      ...item,
      text: item.text[0],
      isSelected: item.id === selectedGender,
    }))
  }, [selectedGender])
}
